import React, { useState, useEffect } from "react";
import { FullBookingPlayerInfo } from "../../types/response/booking";
import { DictionaryType } from "../../types";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { useSelector } from "react-redux";
import { useGetAllPaymentMethodsQuery } from "../../lib/redux/services/sections/Payments";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  useGetAllEventPlayersQuery,
  useGetAllLeaguePlayersQuery,
  useGetAllTournamentPlayersQuery,
  useGetEventByIdQuery,
  useGetLeagueByIdQuery,
  useGetTournamentByIdQuery,
  useReplacePlayerMutation,
} from "../../lib/redux/services/Api";
import { PaymentMethodsType } from "../../types/response/payments";
import { useCheckIfIsNotWaitingPlayerQuery } from "../../lib/redux/services/sections/Leagues-Tournaments";
import { AddPlayerRequest } from "../../types/request/leagues-tournaments";
import {
  Controller,
  useForm,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { toast } from "react-toastify";
import { EmailValidate, toastMessage } from "../../utils/utils";
import Loader from "../skeletons/Loader";
import SelectPlayerBox from "../booking/SelectPlayerBox";
import { useGetAllPlayersQuery } from "../../lib/redux/services/sections/Customers";
import ValidateError from "./ValidateError";
import Input from "./Input";
import { CURRENCY } from "../../constants";
import PhoneNumberInput from "./PhoneNumberInput";
import SingleSearchableSelect from "./SingleSearchableSelect";
import Button from "./Button";
import RadioInput from "./RadioInput";
import Modal from "./Modal";
import MultiplePaymentModal from "./MultiplePaymentModal";

type Props = {
  id: any;
  info?: any;
  join_type: "app" | "club";
  type: "leagues" | "tournaments" | "public" | "private";
  onClose: any;
  player_id: number;
};

function ReplacePlayerModal({ id, info, join_type, type, onClose }: Props) {
  console.log(id);
  console.log(info);
  console.log(type);
  const getFunction = () => {
    switch (type) {
      case "leagues":
        return useGetAllLeaguePlayersQuery;
      case "tournaments":
        return useGetAllTournamentPlayersQuery;
      case "public":
        return useGetAllEventPlayersQuery;
      case "private":
        return useGetAllEventPlayersQuery;
      default:
        return useGetAllEventPlayersQuery;
    }
  };
  const matchType = () => {
    switch (type) {
      case "leagues":
        return "Leagues";
      case "tournaments":
        return "Tournaments";
      case "public":
        return "Public events";
      case "private":
        return "Private events";
      default:
        return "Leagues";
    }
  };

  const [numberOfGuestPlayers, setNumberOfGuestUsers] = useState(0);
  const [hasWallet, setIsHasWallet] = useState(false);
  const [isAllowedMultiplePayment, setIsAllowedMultiplePayment] =
    useState<boolean>(false);
  const [currentPlayerVouchers, setCurrentPlayerVoucher] = useState<
    FullBookingPlayerInfo["vouchers"]
  >([]);
  const [modal, setModal] = useState<{
    state: boolean;
    type: "player" | "teammate";
  }>({
    state: false,
    type: "player",
  });
  const { inputs, shared, leagues_tournaments, events }: DictionaryType =
    useGetDictionary();
  const club_id = useSelector((state: any) => state.user.selectedClub);
  const {
    data: paymentMethods,
    isSuccess: isSuccessPaymentMethod,
    isError: isErrorPaymentMethod,
  } = useGetAllPaymentMethodsQuery({ id: club_id, enabled: 1 });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [replacePlayer] = useReplacePlayerMutation();
  const getByIdApi = () => {
    switch (type) {
      case "leagues":
        return useGetLeagueByIdQuery;
      case "tournaments":
        return useGetTournamentByIdQuery;
      case "public":
        return useGetEventByIdQuery;
      case "private":
        return useGetEventByIdQuery;
      default:
        return useGetLeagueByIdQuery;
    }
  };

  const { data: eventData, isFetching: isFetchingEventData } = getByIdApi()(id);
  console.log(eventData?.data?.price_per_player);
  const [totalPlayers, setTotalPlayers] = useState([]);
  const getPlayersApi = getFunction();
  const { data: players, isFetching: isFetchingPlayers } = getPlayersApi({
    id: id,
    limit: 100,
    currentPage: 1,
    price_per_player: eventData?.data?.price_per_player,
    club_id: club_id,
  });
  const handleOption = (options: any) => {
    let returnedPaymetMethods: PaymentMethodsType[] = options;
    if (players?.allowed_payment === "club") {
      returnedPaymetMethods = returnedPaymetMethods.filter(
        (item: any) => !item.is_app && !item.is_payment_link
      );
    }
    if (players?.allowed_payment === "app") {
      returnedPaymetMethods = returnedPaymetMethods.filter(
        (item: any) =>
          item.is_app ||
          item.is_payment_link ||
          item.is_multiple ||
          item.is_voucher
      );
    }
    if (hasWallet && isAllowedMultiplePayment) {
      return returnedPaymetMethods;
    }
    if (hasWallet && !isAllowedMultiplePayment) {
      returnedPaymetMethods = returnedPaymetMethods.filter(
        (item: any) => !item.is_multiple
      );
      return returnedPaymetMethods;
    }
    if (isAllowedMultiplePayment && !hasWallet) {
      returnedPaymetMethods = returnedPaymetMethods.filter(
        (item: any) => !item.is_voucher
      );
      return returnedPaymetMethods;
    }
    if (!hasWallet && !isAllowedMultiplePayment) {
      returnedPaymetMethods = returnedPaymetMethods.filter(
        (item: any) => !item.is_voucher && !item.is_multiple
      );
      return returnedPaymetMethods;
    }
    return returnedPaymetMethods;
  };

  const { data: isNotWaitingList, isFetching: FetchIsNotWaitinglits } =
    useCheckIfIsNotWaitingPlayerQuery(id);
  //@ts-ignore
  // console.log([watch("teammate_id"), ...totalPlayers]);

  useEffect(() => {
    if (players) {
      const allPlayersIds = players.data.flatMap((player: any) => {
        const ids = [];
        ids.push(player.player_id.id);

        return ids;
      });

      setTotalPlayers(allPlayersIds);
    }
  }, [players]);

  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    setValue,
    getValues,
    trigger,
  } = useForm<AddPlayerRequest>({
    defaultValues: {},
  });
  const playerId = watch("player_id");
  const playerPayment = watch("payment_method_id");

  const playerPrice = watch("player_price");

  const playerVoucher = watch("player_voucher_id");

  const playerMultiplePayments = watch("player_multiple_payments") || [];

  const isVoucherPayment = (paymentMethods: PaymentMethodsType[]): boolean => {
    const currentPaymentObject = paymentMethods.find((item) => item.is_voucher);
    if (
      currentPaymentObject?.id &&
      currentPaymentObject?.id === playerPayment
    ) {
      console.log("true");

      return true;
    } else {
      return false;
    }
  };
  const isMultiplePayment = (paymentMethods: PaymentMethodsType[]): boolean => {
    const playerPayment = watch("payment_method_id");
    const currentPaymentObject = paymentMethods.find(
      (item) => item.is_multiple
    );
    console.log(currentPaymentObject);

    if (
      currentPaymentObject?.id &&
      currentPaymentObject?.id === playerPayment
    ) {
      return true;
    } else {
      return false;
    }
  };
  const onSubmit = async (formData: AddPlayerRequest) => {
    let updatedData;

    updatedData = {
      ...formData,
      league_line_id: info?.line_id,
      player_is_guest: formData.player_id === 0,
      old_player_id: info?.player_id,
      player_nickname:
        formData.player_id === 0 ? null : formData.player_guest_nickname,
    };

    const voucherPaymentMethod = paymentMethods?.data?.find(
      (item) => item.is_multiple
    );
    if (
      formData?.player_id !== 0 &&
      formData?.payment_method_id &&
      formData?.payment_method_id === voucherPaymentMethod?.id
    ) {
      if (!formData?.player_multiple_payments) {
        toast.error(`please select a voucher for player `);
        return;
      }
      if (formData?.player_multiple_payments!?.length === 0) {
        toast.error(`please select a voucher for player `);
        return;
      }
      const price = formData?.player_price;
      const totalPaid = formData?.player_multiple_payments!?.reduce(
        (acc: any, curr: any) => acc + curr.price,
        0
      );
      if (price - totalPaid > 0) {
        toast.error(`please select a voucher covering full price for player `);
        return;
      }
    }

    try {
      await toast.promise(replacePlayer(updatedData).unwrap(), toastMessage());
      onClose?.();
    } catch (error) {}
  };

  console.log(isNotWaitingList);
  if (isFetchingPlayers || FetchIsNotWaitinglits || isFetchingEventData)
    return (
      <div className="h-[542px]">
        <Loader />
      </div>
    );
  return (
    <>
      <h3 className="font-bold text-3xl text-center p-5 ">Change Player</h3>
      <p className="text-center text-sm">Search by email or Mobile number</p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="p-6 text-white rounded-lg flex flex-col gap-6 h-[calc(100%-65px)] justify-between items-start w-full max-w-[500px] px-[60px]"
      >
        <div className="flex flex-col items-start gap-6 w-full">
          <div className="flex flex-col gap-6 justify-center items-start w-full text-start">
            <div className="w-full flex flex-row gap-2">
              <div className="w-full ">
                <label className="block text-sm mb-2 text-primary dark:text-white">
                  {inputs.player_name}
                  <span className="text-red-500">*</span>
                </label>
                <Controller
                  control={control}
                  name={`player_id`}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectPlayerBox
                      field={field}
                      hasGuestAction={true}
                      numberOfGuestPlayers={numberOfGuestPlayers}
                      setNumberOfGuestUsers={setNumberOfGuestUsers}
                      name="player_id"
                      index={0}
                      isCustomOption={true}
                      extraParams={{
                        event_id: id,
                        limit: 50,
                        price_per_player: eventData?.data?.price_per_player,
                        booking_type: type.replace("s", ""),
                      }}
                      HasMenu={true}
                      setValue={setValue}
                      requestFn={useGetAllPlayersQuery}
                      onChange={(selected: any) => {
                        setIsHasWallet(selected.has_voucher);
                        setIsAllowedMultiplePayment(selected.has_multiple);
                        setValue("email", selected.email_address);
                        setValue("phone", selected.mobile_number);
                        setValue("player_id", selected.id);
                        if (selected.id === 0) {
                          setValue("player_guest_nickname", selected.name);
                        }
                        setValue(
                          "player_price",
                          selected.price || eventData?.data?.price_per_player
                        );
                        setValue("player_benefit_id", selected.benefit_id);
                        setValue(
                          "player_membership_id",
                          selected.player_membership_id
                        );
                      }}
                      //@ts-ignore
                      isPlayersSelect={true}
                      excludedValues={totalPlayers}
                      position="bottom"
                    />
                  )}
                />
                {errors.player_id && <ValidateError />}
              </div>

              <div className="w-[30%]">
                <Controller
                  name="player_price"
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) => (
                    <Input
                      inputProps={{
                        ...field,
                        type: "number",
                        onWheel: (e) => {
                          e.preventDefault();
                          //@ts-ignore
                          e.target.blur();
                        },
                      }}
                      label={inputs.price}
                      title={CURRENCY()}
                    />
                  )}
                />
                {errors.player_price &&
                  errors.player_price.type === "required" && <ValidateError />}
              </div>
            </div>
            <div
              className="text-primary dark:text-white flex flex-row items-center gap-1 cursor-pointer "
              onClick={() => {
                let title = leagues_tournaments.return_to_league;
                let back_url = `/competitive/${type}/${type}-players/${id}?${searchParams.toString()}`;
                switch (type) {
                  case "leagues":
                    title = leagues_tournaments.return_to_league;
                    back_url = `/competitive/${type}/${type}-players/${id}?${searchParams.toString()}`;
                    break;
                  case "tournaments":
                    title = leagues_tournaments.return_to_tournament;
                    back_url = `/competitive/${type}/${type}-players/${id}?${searchParams.toString()}`;
                    break;
                  case "public":
                    title = events.return_to_event;
                    back_url = `/friendly/public/event-players/${id}?${searchParams.toString()}`;
                    break;
                  case "private":
                    title = events.return_to_event;
                    back_url = `/friendly/public/event-players/${id}?${searchParams.toString()}`;
                    break;
                  default:
                    title = leagues_tournaments.return_to_league;
                }

                navigate(`/club-settings/customer/new?title=add new customer`, {
                  state: {
                    back_url: `/competitive/${type}/${type}-players/${id}?${searchParams.toString()}`,
                    title:
                      type == "leagues"
                        ? leagues_tournaments.return_to_league
                        : leagues_tournaments.return_to_tournament,
                  },
                });
              }}
            >
              <span className="text-2xl">+</span>{" "}
              <p>{leagues_tournaments.create_customer}</p>
            </div>

            <div className="flex-1 w-full">
              <Controller
                name="email"
                control={control}
                rules={{
                  required: false,
                  pattern: {
                    value: EmailValidate,
                    message: shared.Invalid_email_domain_messsage,
                  },
                }}
                render={({ field }) => (
                  <Input
                    label={inputs.email}
                    inputProps={{
                      ...field,
                      disabled: true,
                      readOnly: true,
                      className:
                        "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    }}
                  />
                )}
              />
              {errors.email && (
                <ValidateError errorMessage={errors.email.message} />
              )}
            </div>

            <div className="w-full">
              <Controller
                name="phone"
                rules={{ required: false }}
                control={control}
                render={({ field }) => (
                  <PhoneNumberInput
                    field={field}
                    isDisabled={true}
                    label={inputs.phone_number}
                    name="mobile_number"
                    value={field.value}
                    handleChange={(value, countryCode) => {
                      field.onChange(value); // Update mobile number
                      //setValue("country_name", countryCode); // Update country name
                    }}
                  />
                )}
              />
              {errors.phone && <ValidateError />}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-6 justify-end items-center w-full ml-auto mr-0">
          <Button
            customeStyle="bg-primary text-white p-3 px-2 rounded-full w-full"
            text={shared.save}
            type="submit"
            width=" max-w-full w-full"
          />

          <Button
            customeStyle="text-red-500 w-full hover:border-red-500 hover:border rounded-full py-3 transition duration-300"
            text={shared.cancel}
            type="reset"
            width=" max-w-full w-full"
            onClick={(e) => {
              e.preventDefault();

              onClose?.();
            }}
          />
        </div>
      </form>
    </>
  );
}

export default ReplacePlayerModal;
